export const tapOnFeesSelectors = {
  gridData: (state) => state.gridData,
  update: (state) => state.update,
}
